<div class="detail-container">
  <nb-card [nbSpinner]="saving() || loading()">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Konzern</h5>
      @if (canEdit() && !isNew()) {
        <wr-edit-delete-button-group
          (edit)="onEdit()"
          (delete)="onDelete()">
        </wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (isEditing()) {
        <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                   status="warning"
                   message="Änderungen an der Zuordnung wirken sofort auf die Sichtbarkeit von Katalogen und Arbeits-Dropdowns.">
        </wr-banner>
      }

      @if (form) {
        <hau-form [formGroup]="form">
          <hau-form-field label="Name" [validation]="form.validation.name" cols="6">
            <input nbInput fullWidth formControlName="name" placeholder="Konzern-Name">
          </hau-form-field>

          <hau-form-field label="Genossenschaften" cols="12">
            <wr-tenant-multi-select [tenantType]="TenantType.External"
                                    formControlName="assignedExternalTenantIds">
            </wr-tenant-multi-select>
          </hau-form-field>

          <hau-form-field label="Firmen" cols="12">
            <wr-tenant-multi-select [tenantType]="TenantType.Internal"
                                    formControlName="memberTenantIds">
            </wr-tenant-multi-select>
          </hau-form-field>
        </hau-form>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing()" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing()" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
